export function calculateDuration(msDuration: string | null) {
    const duration = Number(msDuration)
    if (!duration) {
        return null
    }
    let seconds = Math.floor(duration / 1000)
    const minutes = Math.floor(seconds / 60)

    seconds = seconds % 60

    return `${minutes}:${seconds.toString().padStart(2, '0')}`
}
